import React from "react";

export const PATHS: Record<string, string> = {
  search:    '<circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/>',
  pin:       '<path d="M12 21s7-6.3 7-11a7 7 0 1 0-14 0c0 4.7 7 11 7 11Z"/><circle cx="12" cy="10" r="2.6"/>',
  star:      '<path d="M12 3.5l2.6 5.3 5.9.86-4.25 4.14 1 5.86L12 17.9l-5.25 2.76 1-5.86L3.5 9.66l5.9-.86L12 3.5Z" fill="currentColor" stroke="none"/>',
  store:     '<path d="M4 9.5 5.2 5h13.6L20 9.5M4 9.5h16M4 9.5a2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0M5.5 11.5V19h13v-7.5"/>',
  verified:  '<path d="m12 2.6 2.3 1.7 2.85-.05.9 2.7 2.3 1.7-.9 2.7.9 2.7-2.3 1.7-.9 2.7-2.85-.05L12 21.4l-2.3-1.7-2.85.05-.9-2.7-2.3-1.7.9-2.7-.9-2.7 2.3-1.7.9-2.7 2.85.05L12 2.6Z"/><path d="m9 12 2 2 4-4"/>',
  spark:     '<path d="M12 3v4M12 17v4M4.2 7.5l2.8 1.6M17 14.9l2.8 1.6M19.8 7.5 17 9.1M7 14.9l-2.8 1.6"/><circle cx="12" cy="12" r="3.2"/>',
  users:     '<circle cx="9" cy="8" r="3"/><path d="M3.5 19a5.5 5.5 0 0 1 11 0M16 6.2a3 3 0 0 1 0 5.6M21 19a5.4 5.4 0 0 0-3.5-5"/>',
  comment:   '<path d="M21 12a8 8 0 0 1-11.6 7.1L4 20.5l1.4-5.3A8 8 0 1 1 21 12Z"/>',
  badge:     '<path d="M12 3.5 14 7l4 .6-2.9 2.8.7 4-3.8-2-3.8 2 .7-4L4 7.6 8 7l2-3.5Z" fill="currentColor" stroke="none"/>',
  pencil:    '<path d="M5 19h3l9-9-3-3-9 9v3Z"/><path d="m13.5 6.5 3 3"/>',
  shield:    '<path d="M12 3.2 5 6v5.5c0 4.3 3 7.3 7 9.3 4-2 7-5 7-9.3V6l-7-2.8Z"/><path d="m9 12 2 2 4-4"/>',
  arrow:     '<path d="M19 12H5M11 6l-6 6 6 6"/>',
  whatsapp:  '<path d="M20 12a8 8 0 0 1-11.9 7L4 20l1-4.1A8 8 0 1 1 20 12Z"/><path d="M9 9.5c0 3 2.5 5.5 5.5 5.5.6 0 1-.5 1-.5l-1.3-1.2-1 .5c-1-.4-1.8-1.2-2.2-2.2l.5-1L10.3 9s-.5.4-.5 1Z" fill="currentColor" stroke="none"/>',
  tag:       '<path d="M4 13 11 6h6v6l-7 7-6-6Z"/><circle cx="14" cy="9" r="1.2"/>',
  cup:       '<path d="M7 8h10l-1 11.4a1.5 1.5 0 0 1-1.5 1.3h-4a1.5 1.5 0 0 1-1.5-1.3L7 8Z"/><path d="M6 8h12M9.5 5h5"/>',
  device:    '<rect x="7.5" y="3.5" width="9" height="17" rx="2"/><path d="M10.5 17.5h3"/>',
  bottle:    '<path d="M10.5 3h3v2.8l1.3 2.4V20a1 1 0 0 1-1 1h-3.6a1 1 0 0 1-1-1V8.2l1.3-2.4V3Z"/><path d="M9.5 12.5h5"/>',
  home:      '<path d="M4 11 12 4.5 20 11M6 9.5V20h12V9.5"/>',
  book:      '<path d="M5 4.5h8.5a2 2 0 0 1 2 2V20a2.5 2.5 0 0 0-2.5-1.6H5V4.5Z"/><path d="M19 4.5v13.9"/><path d="M6 8h7M6 11h7"/>',
  gift:      '<rect x="4.5" y="10" width="15" height="10" rx="1.5"/><path d="M4 10h16v3H4zM12 10v10"/><path d="M8.5 6.3a2 2 0 0 0 0 3.7h3.5M15.5 6.3a2 2 0 0 1 0 3.7H12"/>',
  quoteMark: '<path d="M9.5 6C6.9 6 5 8 5 10.6c0 2.3 1.7 4 3.9 4 .2 1.9-.9 3.3-2.7 3.9-.3.1-.4.5-.2.7.1.2.4.3.6.2C9.4 19 11.5 16.4 11.5 13V10.6C11.5 8 10.7 6 9.5 6ZM18.5 6C15.9 6 14 8 14 10.6c0 2.3 1.7 4 3.9 4 .2 1.9-.9 3.3-2.7 3.9-.3.1-.4.5-.2.7.1.2.4.3.6.2C18.4 19 20.5 16.4 20.5 13V10.6C20.5 8 19.7 6 18.5 6Z" fill="currentColor" stroke="none"/>',
  eye:       '<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z"/><circle cx="12" cy="12" r="3"/>',
  scale:     '<path d="M12 4v16M7.5 6.5h9M8 20h8"/><path d="M4.5 7 2 13h5L4.5 7ZM19.5 7 17 13h5l-2.5-6Z"/><path d="M2 13a2.5 2.5 0 0 0 5 0M17 13a2.5 2.5 0 0 0 5 0"/>',
  heart:     '<path d="M12 20s-7-4.4-9-9a4.5 4.5 0 0 1 9-2 4.5 4.5 0 0 1 9 2c-2 4.6-9 9-9 9Z"/>',
  lock:      '<rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>',
  // ── category icons ──
  shirt:     '<path d="M8 4 4 6.2l1.6 3.8L8 9v11h8V9l2.4 1L20 6.2 16 4a2.4 2.4 0 0 1-8 0Z"/>',
  dress:     '<path d="M9 3 8 7l1.6 2L8 20h8l-1.6-11L16 7l-1-4M9 3h6"/>',
  dumbbell:  '<path d="M6.5 8v8M4 9.5v5M17.5 8v8M20 9.5v5M6.5 12h11"/>',
  sofa:      '<path d="M4 12V9a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3M4 12a2 2 0 0 0-1 1.7V17h18v-3.3A2 2 0 0 0 20 12M7 7v5M17 7v5M6 17v2M18 17v2"/>',
  gamepad:   '<rect x="2.5" y="7" width="19" height="10" rx="4"/><path d="M6.5 11v2M5.5 12h2M15.5 11.5h.01M17.5 13.5h.01"/>',
  fridge:    '<rect x="6" y="3" width="12" height="18" rx="2"/><path d="M6 10.5h12M9.5 6v2M9.5 13v3"/>',
  laptop:    '<rect x="5" y="5" width="14" height="10" rx="1.5"/><path d="M3 18.5h18"/>',
  cart:      '<circle cx="9.5" cy="19" r="1.3"/><circle cx="16.5" cy="19" r="1.3"/><path d="M3 4h2.2l1.8 11h10l2-7.5H6.2"/>',
  chip:      '<rect x="7" y="7" width="10" height="10" rx="1.5"/><path d="M10 4v3M14 4v3M10 17v3M14 17v3M4 10h3M4 14h3M17 10h3M17 14h3"/>',
};

type IconProps = {
  n: keyof typeof PATHS;
  s?: number;
  sw?: number;
  style?: React.CSSProperties;
  className?: string;
};

export default function Icon({ n, s = 20, sw = 1.8, style, className }: IconProps) {
  return (
    <svg
      className={"ic" + (className ? " " + className : "")}
      width={s}
      height={s}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: PATHS[n] || "" }}
    />
  );
}
